module.exports = __webpack_public_path__ + "static/img/strona_046.7a7d5cc7.jpg";